<template>
  <b-form v-if="form" class="mt-4" @submit.prevent="submit">
    <b-row>

      <b-col cols="6">
        <b-form-group
          id="input-group-first-name"
          label="First name"
          label-for="input-first-name"
        >
          <b-form-input
            id="input-first-name"
            v-model.trim="form.firstName"
            v-validate="{ required: true, max: 100 }"
            type="text"
            placeholder="First name"
            size="lg"
            data-vv-name="first-name"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group
          id="input-group-last-name"
          label="Last name"
          label-for="input-last-name"
        >
          <b-form-input
            id="input-last-name"
            v-model.trim="form.lastName"
            v-validate="{ required: true, max: 100 }"
            type="text"
            placeholder="Last name"
            size="lg"
            data-vv-name="last-name"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group
          id="input-group-email"
          label="Email"
          label-for="input-email"
        >
          <b-form-input
            id="input-email"
            v-model.trim="form.email"
            v-validate="'email'"
            type="text"
            placeholder="Email"
            size="lg"
            data-vv-name="email"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <!-- <b-col cols="6">
        <b-form-group
          id="input-group-first-name"
          label="First name"
          label-for="input-first-name"
        >
          <b-form-input
            id="input-first-name"
            v-model.trim="form.firstName"
            v-validate="{ required: true, max: 100 }"
            type="text"
            placeholder="First name"
            size="lg"
            data-vv-name="first-name"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group
          id="input-group-last-name"
          label="Last name"
          label-for="input-last-name"
        >
          <b-form-input
            id="input-last-name"
            v-model.trim="form.lastName"
            v-validate="{ required: true, max: 100 }"
            type="text"
            placeholder="Last name"
            size="lg"
            data-vv-name="last-name"
          ></b-form-input>
        </b-form-group>
      </b-col> -->

      <!-- <b-col cols="6">
        <b-form-group
          id="input-group-projects"
          label="Projects"
          label-for="input-projects"
        >
          <v-select
            v-model="form.projects"
            multiple
            :options="projectsByDateDesc"
            :close-on-select="false"
            label="name"
            placeholder="Select one or more projects"
          ></v-select>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group
          v-if="showPassword"
          id="input-group-password"
          label="Password"
          label-for="input-password"
        >
          <b-form-input
            id="input-password"
            v-model.trim="form.password"
            v-validate="{ required: true, max: 100 }"
            type="password"
            placeholder="Password"
            size="lg"
            data-vv-name="password"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group
          v-if="showPassword"
          id="input-group-password-confirm"
          label="Confirm password"
          label-for="input-password-confirm"
        >
          <b-form-input
            id="input-password-confirm"
            v-model.trim="form.password_confirm"
            v-validate="{ required: true, max: 100, is: form.password }"
            type="password"
            placeholder="Password-confirm"
            size="lg"
            data-vv-name="password-confirm"
          ></b-form-input>
        </b-form-group>
      </b-col>
      -->
      <b-col cols="6">
        <b-form-group id="input-role" label="Role" label-for="input-role">
          <b-form-select
            v-model="form.role"
            v-validate="{ required: true }"
            :options="roles"
            data-vv-name="Role"
            size="lg"
          ></b-form-select>
        </b-form-group>
      </b-col> 

      <b-col class="text-right" cols="12">
        <div class="form-footer">
          <b-btn variant="primary" size="lg" type="submit">
            <i class="fa fa-plus" /> Save
          </b-btn>
        </div>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";

export default {
  name: "UserForm",
  components: {
    vSelect,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    showPassword: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapGetters(["authenticatedUser", "projectsByDateDesc"]),
    projects() {
      let projects = [];
      this.projectsByDateDesc.map((p) => {
        projects.push({ label: p.name, code: p.id });
      });
      return projects;
    },
    roles() {
      let roles = [{ value: "user", text: "User" }];

      if (
        this.authenticatedUser.role === "root" ||
        this.authenticatedUser.role === "admin"
      ) {
        roles.push({ value: "admin", text: "Admin" });
      }

      if (this.authenticatedUser.role === "root") {
        roles.push({ value: "root", text: "Root" });
      }

      return roles;
    },
    userFullName() {
      return this.form.fullName === "null null" ? "Full name" : this.form.fullName;
    },
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error",
          });
          return;
        }

        this.$emit("callback");
      });
    },
  },
};
</script>
